"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import styled from "styled-components";
import { getExternalLinkProps } from "../../utils";
import { Progress, ProgressColor } from "../Progress";
import StyledButton from "./StyledButton";
const Button = t0 => {
  const $ = _c(46);
  let $isLoading;
  let children;
  let disabled;
  let endIcon;
  let external;
  let initChatSession;
  let onClick;
  let props;
  let ref;
  let startIcon;
  let style;
  let t1;
  let t2;
  let t3;
  let text;
  if ($[0] !== t0) {
    ({
      text,
      startIcon,
      style,
      endIcon,
      children,
      external,
      $isLoading,
      disabled,
      $error: t1,
      loading: t2,
      $onlyIcon: t3,
      initChatSession,
      ref,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = $isLoading;
    $[2] = children;
    $[3] = disabled;
    $[4] = endIcon;
    $[5] = external;
    $[6] = initChatSession;
    $[7] = onClick;
    $[8] = props;
    $[9] = ref;
    $[10] = startIcon;
    $[11] = style;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = text;
  } else {
    $isLoading = $[1];
    children = $[2];
    disabled = $[3];
    endIcon = $[4];
    external = $[5];
    initChatSession = $[6];
    onClick = $[7];
    props = $[8];
    ref = $[9];
    startIcon = $[10];
    style = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    text = $[15];
  }
  const $error = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const $onlyIcon = t3 === undefined ? false : t3;
  let t4;
  if ($[16] !== external) {
    t4 = external ? getExternalLinkProps() : {};
    $[16] = external;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const internalProps = t4;
  const isDisabled = $isLoading || disabled;
  const t5 = loading === true ? true : undefined;
  const t6 = disabled ? undefined : onClick;
  let t7;
  if ($[18] !== $onlyIcon || $[19] !== startIcon) {
    t7 = startIcon && <IconWrapper $onlyIcon={$onlyIcon} $position="start">{startIcon}</IconWrapper>;
    $[18] = $onlyIcon;
    $[19] = startIcon;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== $onlyIcon || $[22] !== loading || $[23] !== text) {
    t8 = loading ? <Progress color={ProgressColor.GRAYSCALE_400} /> : !$onlyIcon && <TextWrapper>{text}</TextWrapper>;
    $[21] = $onlyIcon;
    $[22] = loading;
    $[23] = text;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== $onlyIcon || $[26] !== endIcon) {
    t9 = endIcon && <IconWrapper $onlyIcon={$onlyIcon} $position="end">{endIcon}</IconWrapper>;
    $[25] = $onlyIcon;
    $[26] = endIcon;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== children || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t10 = <>{t7}{children}{t8}{t9}</>;
    $[28] = children;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== $error || $[34] !== $isLoading || $[35] !== $onlyIcon || $[36] !== initChatSession || $[37] !== internalProps || $[38] !== isDisabled || $[39] !== props || $[40] !== ref || $[41] !== style || $[42] !== t10 || $[43] !== t5 || $[44] !== t6) {
    t11 = <StyledButton ref={ref} {...internalProps} {...props} $isLoading={$isLoading} disabled={isDisabled} style={style} $error={$error} loading={t5} $onlyIcon={$onlyIcon} initChatSession={initChatSession} onClick={t6}>{t10}</StyledButton>;
    $[33] = $error;
    $[34] = $isLoading;
    $[35] = $onlyIcon;
    $[36] = initChatSession;
    $[37] = internalProps;
    $[38] = isDisabled;
    $[39] = props;
    $[40] = ref;
    $[41] = style;
    $[42] = t10;
    $[43] = t5;
    $[44] = t6;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  return t11;
};
const TextWrapper = styled.span`
  width: max-content;
  white-space: nowrap;
`;
const IconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-right: ${({
  $onlyIcon,
  $position
}) => !$onlyIcon && $position === "start" ? "8px" : "0"};
  margin-left: ${({
  $onlyIcon,
  $position
}) => !$onlyIcon && $position === "end" ? "8px" : "0"};
`;
export default Button;